<template>
  <v-btn-toggle mandatory style="width: 100%">
    <v-btn
      large
      v-for="item in items"
      :key="item.status"
      @click="setGroupStatus(item.status)"
      style="flex: 1"
    >
      <v-icon left :color="colorStatus(item.status)" size="16">
        mdi-circle
      </v-icon>
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "components-common-filters-group-status",
  data: () => ({}),
  computed: {
    items() {
      return [
        { text: "OK", status: 1 },
        { text: this.$t("didCancelled"), status: 0 },
      ];
    },
  },
  methods: {
    setGroupStatus(status) {
      this.$store.commit("setGroupStatus", status);
    },
    colorStatus(status) {
      if (status == 0) return "purple";
      if (status == 1) return "green";
    },
  },
};
</script>
